import type { CityConfig } from "../city-template/types";

export const detroitConfig: CityConfig = {
  city: "Detroit",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "detroit",
  route: "/cities/detroit",
  title: "Emergency Passport Detroit MI | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Detroit, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Detroit, Dearborn, Warren, Sterling Heights, and all Metro Detroit residents. Detroit Passport Agency alternative. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Detroit, MI",
  heroSubtitle: "Detroit travelers — from Motor City executives to auto industry professionals to international families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. Home of the Detroit Passport Agency. A+ BBB rated courier service serving all of Metro Detroit and Southeast Michigan.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20aerial%20view%20of%20Detroit%20Michigan%20downtown%20skyline%20at%20golden%20hour%20with%20the%20Renaissance%20Center%20towers%20rising%20prominently%20along%20the%20Detroit%20River%2C%20Ambassador%20Bridge%20visible%20in%20the%20background%2C%20Canadian%20Windsor%20skyline%20across%20the%20water%2C%20rich%20warm%20light%20casting%20long%20shadows%20across%20the%20city%20grid%2C%20modern%20skyscrapers%20and%20historic%20architecture%20blending%20together%2C%20no%20text%20no%20people%2C%20cinematic%20city%20photography&width=1800&height=700&seq=detroit-hero-002&orientation=landscape",
  heroImageAlt: "Detroit Michigan downtown skyline with Renaissance Center along the Detroit River at golden hour",
  geoPosition: "42.3314;-83.0458",
  geoPlacename: "Detroit, Michigan",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "211 W. Fort St, Suite 1300, Detroit, MI 48226",
    distance: "Located in downtown Detroit — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Detroit", zips: "48201, 48202, 48203, 48204, 48205, 48206, 48207, 48208, 48209, 48210, 48211, 48212, 48213, 48214, 48215, 48216, 48217, 48219, 48221, 48223, 48224, 48226, 48227, 48228, 48234, 48235, 48238, 48239, 48240" },
    { name: "Dearborn", zips: "48120, 48121, 48123, 48124, 48125, 48126, 48128" },
    { name: "Warren", zips: "48088, 48089, 48091, 48092, 48093" },
    { name: "Sterling Heights", zips: "48310, 48311, 48312, 48313, 48314" },
    { name: "Livonia", zips: "48150, 48151, 48152, 48153, 48154" },
    { name: "Canton", zips: "48187, 48188" },
    { name: "Westland", zips: "48185, 48186" },
    { name: "Taylor", zips: "48180" },
    { name: "Southfield", zips: "48033, 48034, 48075, 48076" },
    { name: "Troy", zips: "48083, 48084, 48085, 48098, 48099" },
    { name: "Royal Oak", zips: "48067, 48068, 48069, 48073" },
    { name: "Pontiac", zips: "48340, 48341, 48342, 48343" },
    { name: "Farmington Hills", zips: "48331, 48333, 48334, 48335, 48336" },
    { name: "Dearborn Heights", zips: "48125, 48127" },
    { name: "Roseville", zips: "48066" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "Canada Border Expertise", desc: "Ambassador Bridge, Windsor Tunnel, Blue Water Bridge passport requirements" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — stay home while we do the work" },
  ],
  internalLinks: [
    { name: "Expedited passport in Dearborn, MI", route: "/states/michigan" },
    { name: "Emergency passport services in Ann Arbor, MI", route: "/cities/ann-arbor" },
    { name: "Urgent passport services in Warren, MI", route: "/states/michigan" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Detroit, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Detroit residents can ship from any UPS or FedEx in Metro Detroit.",
  fpcOfficeDistance: "Serving Detroit, Dearborn, Warren, Sterling Heights, Livonia, Canton, Westland, Southfield, Troy, Royal Oak, and all of Metro Detroit",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Detroit and the greater Metro Detroit area. From the Renaissance Center in downtown Detroit to the auto plants in Dearborn, from the northern suburbs of Troy and Southfield to the Downriver communities — we serve all of Wayne, Oakland, and Macomb counties. Detroit is home to Michigan's only regional passport agency, and our couriers have direct access to it.",
  nearbyCitiesIntro: "We serve Detroit and all Metro Detroit communities including Dearborn, Warren, Sterling Heights, Livonia, Canton, Westland, Taylor, Southfield, Troy, Royal Oak, Pontiac, Farmington Hills, Dearborn Heights, and Roseville. We also serve eastern Michigan including Windsor-area Canada border travelers.",
  howItWorksIntro: "Most Detroit travelers complete everything online and ship documents overnight. No waiting weeks for a passport agency appointment — our registered couriers handle the Detroit Passport Agency submission for you.",
  mistakesIntro: "Detroit is a major international city with a large international population and unique Canada border crossing needs. Here are the most common passport mistakes we see from Metro Detroit travelers.",
  testimonialsIntro: "Detroit travelers — from auto industry executives to international students to families crossing to Windsor — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Detroit, MI? Here are the most common ones we hear from Metro Detroit travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person downtown Detroit", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for business and Canada border travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Detroit travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency in downtown Detroit. Perfect for last-minute business trips, family emergencies, and international trade travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Canada border and international travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Detroit adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Metro Detroit address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Detroit residents and families — including international students, new citizens, and Metro Detroit families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Detroit residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Detroit-area families planning international vacations or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Detroit and Metro Detroit residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Detroit MI", description: "Urgent passport processing for Detroit Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Detroit MI", description: "Fast passport renewal for Detroit Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Detroit MI", description: "New passport application services for Detroit Michigan residents applying for their first passport." },
    { name: "Child Passport Detroit MI", description: "Minor passport services for Detroit Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "James T.",
      location: "Detroit, MI",
      rating: 5,
      text: "Business trip to Germany in 4 days and my passport was expired. Fast Passport Center handled everything — delivered my renewed passport in 36 hours. Their courier literally walked into the Detroit agency while I was at work. Incredible service.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Maria G.",
      location: "Dearborn, MI",
      rating: 5,
      text: "Family vacation to Mexico with 8 days notice. Four passports for our whole family — two renewals and two first-time. Done in 5 days. We shipped from the FedEx on Michigan Ave and everything went smooth.",
      service: "Family Passport Bundle",
    },
    {
      name: "David K.",
      location: "Troy, MI",
      rating: 5,
      text: "Auto industry conference in Tokyo and I realized my passport was expiring too soon. Fast Passport Center got me a renewed passport in 2 days. The process was completely hands-off from my end.",
      service: "Passport Renewal",
    },
    {
      name: "Fatima A.",
      location: "Sterling Heights, MI",
      rating: 5,
      text: "Needed to cross to Windsor Canada for a family emergency and lost my passport the day before. Fast Passport Center walked me through the process and had a replacement in my hands in 48 hours. Outstanding.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "detroit-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "211 W. Fort St, Suite 1300",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Downtown Detroit — appointments typically booked 2 weeks out",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "detroit-2",
      name: "Detroit Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1401 W Fort St",
      city: "Detroit",
      state: "MI",
      zip: "48233",
      phone: "(313) 226-8305",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown/Corktown Detroit — near the Lodge Freeway",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown Detroit acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to Corktown, Midtown, and downtown office workers.",
      icon: "ri-mail-line",
    },
    {
      id: "detroit-3",
      name: "Eastland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "19800 Kelly Rd",
      city: "Detroit",
      state: "MI",
      zip: "48224",
      phone: "(313) 882-1110",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East Detroit, near Grosse Pointe border",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for East Detroit and Grosse Pointe area residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "detroit-4",
      name: "Dearborn Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "19660 Ford Rd",
      city: "Dearborn",
      state: "MI",
      zip: "48128",
      phone: "(313) 943-4311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Dearborn — approximately 8 miles west of downtown Detroit",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular with Dearborn's large international community. Ample parking. Serves Dearborn, Dearborn Heights, and surrounding areas.",
      icon: "ri-mail-line",
    },
    {
      id: "detroit-5",
      name: "Sterling Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40111 Dodge Park Rd",
      city: "Sterling Heights",
      state: "MI",
      zip: "48313",
      phone: "(586) 247-4000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Sterling Heights, approximately 18 miles north of downtown Detroit",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Macomb County residents including Sterling Heights, Warren, and Clinton Township. Book early — high demand during summer.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Metro Detroit" },
    { feature: "Canada Border Expertise", agency: "No tailored advice", fpc: "Yes — Ambassador Bridge, Windsor Tunnel, Blue Water Bridge" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Detroit auto industry professionals and international travelers often discover passport issues right before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for Air Travel to Canada",
      description: "Many Detroit-area residents crossing to Windsor use a passport card or enhanced license — but these are not valid for air travel. If you fly to Canada, you need a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Detroit-area acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Canada Entry Requirements",
      description: "Canada has its own entry requirements separate from passport validity. Detroit-Windsor travelers should verify current Canadian customs and immigration rules before crossing.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Metro Detroit." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Metro Detroit." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Detroit-area address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the Detroit Passport Agency?", a: "The Detroit Passport Agency is located at 211 W. Fort St, Suite 1300, Detroit, MI 48226, in the Patrick V. McNamara Federal Building in downtown Detroit. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access to submit applications without individual appointments." },
    { q: "How fast can I get an emergency passport in Detroit?", a: "Fast Passport Center offers emergency passport processing in Detroit, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to take a day off work or find parking in downtown Detroit." },
    { q: "Do I need a passport to cross the Ambassador Bridge to Canada?", a: "For air travel to Canada, yes — you need a passport book. For land crossings via the Ambassador Bridge, Detroit-Windsor Tunnel, Blue Water Bridge, or other Michigan-Canada crossings, U.S. citizens can use a passport book, passport card, enhanced driver's license, or Trusted Traveler card (NEXUS, SENTRI, Global Entry). A passport book provides the most flexibility for all types of travel." },
    { q: "Can I get an expedited passport in the Detroit suburbs like Dearborn, Warren, or Troy?", a: "Absolutely. Fast Passport Center serves all of Metro Detroit including Dearborn, Warren, Sterling Heights, Livonia, Canton, Westland, Taylor, Southfield, Troy, Royal Oak, Pontiac, Farmington Hills, Macomb, and all surrounding communities. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Detroit-area travelers use for international flights?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub for Metro Detroit. DTW offers direct flights to London, Amsterdam, Tokyo, Mexico City, Cancun, and dozens of other international destinations. Delta Air Lines hub. Windsor Airport (YQG) is a secondary option for some travelers crossing to Canada. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Detroit, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Detroit-area residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Metro Detroit offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve the Upper Peninsula of Michigan?", a: "Yes. Fast Passport Center's courier service is especially valuable for Upper Peninsula residents, who would otherwise face an 8+ hour drive to the Detroit Passport Agency. We serve Marquette, Sault Ste. Marie, Houghton, Escanaba, and all UP communities — you just ship your documents overnight and we handle everything from there." },
  ],
  photoLocations: [
    { name: "Walgreens — Woodward Ave Detroit", address: "1401 Woodward Ave, Detroit, MI 48226", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Dearborn", address: "22011 Michigan Ave, Dearborn, MI 48124", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Downtown Detroit", address: "1001 Woodward Ave, Detroit, MI 48226", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Troy", address: "675 E Big Beaver Rd, Troy, MI 48083", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Detroit", address: "7310 Woodward Ave, Detroit, MI 48202", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Dearborn", address: "3200 Greenfield Rd, Dearborn, MI 48120", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Dearborn and southwest Detroit communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "20–30 minutes from downtown Detroit via I-94 or I-96",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Metro Detroit. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "DTW",
      name: "Coleman A. Young Detroit City Airport",
      distance: "10 minutes from downtown Detroit — domestic/charter only",
      address: "11499 Conner St, Detroit, MI 48213",
      note: "Smaller city airport primarily for charter and private flights. Not used for international travel. DTW remains the main gateway for international departures.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "Metro Airport Info",
      featured: false,
    },
    {
      code: "YQG",
      name: "Windsor Airport (Canada)",
      distance: "20–25 minutes from downtown Detroit via Ambassador Bridge",
      address: "3200 County Rd 42, Windsor, ON N9A 6J3, Canada",
      note: "Secondary option for Detroit travelers crossing to Canada first. Smaller airport with limited international routes. Requires passport for air travel to/from Canada.",
      flightUrl: "https://www.yqg.ca/",
      flightLabel: "Windsor Airport Info",
      featured: false,
    },
  ],
};